"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemSectionStyleType = exports.MenuItemSectionLabelType = void 0;
var MenuItemSectionLabelType;
(function (MenuItemSectionLabelType) {
    MenuItemSectionLabelType["HEADING"] = "HEADING";
    MenuItemSectionLabelType["SUBHEADING"] = "SUBHEADING";
    MenuItemSectionLabelType["LINK"] = "LINK";
    MenuItemSectionLabelType["TEXT"] = "TEXT";
})(MenuItemSectionLabelType = exports.MenuItemSectionLabelType || (exports.MenuItemSectionLabelType = {}));
var MenuItemSectionStyleType;
(function (MenuItemSectionStyleType) {
    MenuItemSectionStyleType["COLUMN"] = "COLUMN";
    MenuItemSectionStyleType["ROW"] = "ROW";
})(MenuItemSectionStyleType = exports.MenuItemSectionStyleType || (exports.MenuItemSectionStyleType = {}));
//# sourceMappingURL=global-components-context.js.map